import {cashBoxRegister} from "../../../hoc/cashBoxRegister";

const CashBoxCashInRegister = cashBoxRegister("CashBoxCashInRegister")

export default CashBoxCashInRegister
